module.exports = __webpack_public_path__ + "img/f_g1_starhairtie.e19fe29d.jpg";